import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { joinClassNames } from '../../utils';
import './_styles_/ConnectionIndicator.css';
import {
    CHECKING,
    CONNECTED,
    DISCONNECTED,
    ERROR,
    getConnectionStatus,
} from '../../utils/ConnectionStatuses';

ConnectionIndicator.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
};

const STATUS_CLASS = new Map([
    [CONNECTED, 'indicator-connected'],
    [DISCONNECTED, 'indicator-disconnected'],
    [CHECKING, 'indicator-checking'],
    [ERROR, 'indicator-error'],
]);

function ConnectionIndicator(props) {
    const {
        className = '',
        message,
        status,
    } = props;
    const { t } = useTranslation();
    const resolvedStatus = getConnectionStatus(status);
    const statusClass = STATUS_CLASS.get(resolvedStatus) ?? 'indicator-error';

    return (
        <div className={joinClassNames('connection-indicator', 'field', 'readonly', className)}>
            <span className={`connection-indicator-dot field--value ${statusClass}`} />
            <span className="connection-indicator-text field--value">
                {message}: {resolvedStatus.translate(t)}
            </span>
        </div>
    );
}

export default ConnectionIndicator;
